import { useEffect, useState } from 'react';

interface TypewriterTextProps {
  text: string;
  speed?: number;
  delay?: number;
  step?: number;
  className?: string;
  onComplete?: () => void;
}

export const TypewriterText = ({ 
    text, 
    speed = 20, 
    delay = 0, 
    step = 1,
    className = '', 
    onComplete 
}: TypewriterTextProps) => {
    const [displayText, setDisplayText] = useState('');
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isStarted, setIsStarted] = useState(false);

    useEffect(() => {
        if (delay > 0) {
            const delayTimer = setTimeout(() => {
                setIsStarted(true);
            }, delay);
            return () => clearTimeout(delayTimer);
        } else {
            setIsStarted(true);
        }
    }, [delay]);

    useEffect(() => {
        if (!isStarted || currentIndex >= text.length) {
            if (currentIndex >= text.length && onComplete) {
                onComplete();
            }
            return;
        }

        const timer = setTimeout(() => {
            const nextIndex = Math.min(currentIndex + step, text.length);
            setDisplayText(text.slice(0, nextIndex));
            setCurrentIndex(nextIndex);
        }, speed);

        return () => clearTimeout(timer);
    }, [currentIndex, text, speed, step, isStarted, onComplete]);

    return <span className={className}>{displayText}</span>;
};

export default TypewriterText;